/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { ENTITY_TYPES } from '../../../constants/Repository.constants';
import { RECOMMENDED_RUNTIME_IMAGE } from '../../../constants/RuntimeImage.constants';
import { JobRecord } from '../Job';

export const createMockJobRecord = (partialRecord: Partial<JobRecord> = {}): JobRecord => {
  const tenant = faker.string.uuid();
  const version = Array.from({ length: 3 })
    .map(() => faker.number.int())
    .join('.');

  return {
    pk: `${ENTITY_TYPES.job}~${tenant}`,
    sk: `${faker.lorem.word()}-${faker.lorem.word()}`,
    name: faker.lorem.word(),
    description: faker.lorem.sentence(),
    version,
    image: RECOMMENDED_RUNTIME_IMAGE,
    ...partialRecord,
  };
};

export const createMockJobRecords = (size?: number): Array<JobRecord> => {
  const randomSize = size ?? faker.number.int({ max: 3, min: 1 });
  return Array.from({ length: randomSize }).map(() => createMockJobRecord());
};
